import PropTypes from 'prop-types'
import {Map} from 'immutable'

import DownloadStatus from '../../../../../shared_components/DownloadStatus'

const MemorialGuideDownloadStatus = ({memorialGuideDownload}) => {
  if (memorialGuideDownload.isEmpty() || memorialGuideDownload.get('status') === 'ready')
    return null
  else
    return <DownloadStatus />
}

MemorialGuideDownloadStatus.propTypes = {
  memorialGuideDownload: PropTypes.instanceOf(Map).isRequired
}

export default MemorialGuideDownloadStatus
